import {Loader2} from "lucide-react";

/** In-dialog "Checking…" beat. Absolutely positioned to cover the gate body without unmounting it. */
export function ComplianceReconcileOverlay() {
  return (
    <div className="absolute inset-0 z-10 flex items-center justify-center gap-3 rounded-[inherit] bg-background/90">
      <Loader2 className="size-5 animate-spin text-primary" />
      <span className="text-sm text-muted-foreground">Checking…</span>
    </div>
  );
}
